/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Observable } from 'rxjs';
import { Txn } from '@src/app/model/txn';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { PurchaseService } from '@src/app/modules/txn/purchase.service';

export class ApproveForPaymentAction implements IFormAction {
    name = $localize`Approve`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'thumb_up';
    approvalNeeded = true;
    approvalText = $localize`Approve this invoice to be paid to vendor`;
    txn: Txn;

    action(txn: Txn, config: FormConfig): Observable<Txn> {
        return (config.service as PurchaseService).approve(this.txn);
    }

    setup(txn: Txn) {
        this.txn = txn;
        this.show = txn.refNr > 0 && !txn.approvedAt;
    }
}
